<template>
  <div>
    <breadcrumbs :back="[{text:'Scheduling',to:{name:'PlanningScheduling'}}]" home="Roles"/>

    <v-container fluid class="pt-8 px-8">
      <v-row>
        <v-col cols="12" sm="4">
          <outlined-block title="Roles" class="pt-1">
            <v-btn fab color="primary" small class="mt-2 ml-2" @click="crupdateRole=null;showSetRole=true"><v-icon>mdi-plus</v-icon></v-btn>
            <v-list dense class="mb-1 overflow-y" :height="$vuetify.breakpoint.mobile ? '400px' : 'calc(100vh - 230px)'">
              <v-list-item v-for="role of roles" :key="role.id" :ripple="false"
                           @click="selectUsersInRole(role)"
                           @dblclick="crupdateRole=role;showSetRole=true">
                <v-list-item-icon @click="deleteRole(role)"><v-icon small>mdi-delete</v-icon></v-list-item-icon>
                <div :class="{'blue--text font-weight-bold':selectedRole===role.id}">{{role.name}}</div>
              </v-list-item>
            </v-list>
          </outlined-block>
        </v-col>

        <v-col cols="12" sm="4">
          <outlined-block :title="'Users'+(selectedRole?' for ' + roles.find(role => role.id === selectedRole).name:'')" class="pt-1" :disabled="!selectedRole">
            <v-list dense class="my-1 overflow-y" :height="$vuetify.breakpoint.mobile ? '400px' : 'calc(100vh - 186px)'">
              <v-list-item v-for="user of users" :key="user.id" :ripple="false">
                <v-list-item-icon><v-simple-checkbox v-model="user.selected" @click="setUsers()"/></v-list-item-icon>
                {{user.name}}
              </v-list-item>
            </v-list>
          </outlined-block>
        </v-col>
      </v-row>
    </v-container>

    <planning-scheduling-roles-crupdate :role="crupdateRole" v-model="showSetRole" @update="setRole($event, false)" @create="setRole($event, true)"/>
    <delete-object v-model="showDelete" :name="deleteRoleObject.name" @delete="performDeleteRole"/>
  </div>
</template>

<script>
import PlanningSchedulingRolesCrupdate from '@/views/planning/scheduling/PlanningSchedulingRolesCrupdate'

export default {
  name: 'PlanningSchedulingRoles',
  components: {PlanningSchedulingRolesCrupdate},
  data () {
    return {
      roles: [],
      users: [],
      crupdateRole: null,
      selectedRole: '',
      showSetRole: false,
      deleteRoleObject: {},
      showDelete: false
    }
  },
  async created() {
      this.loading = true;
      const results = await this.$apiCall(`query PlanningSchedulingRoles {
                                              roles {
                                                id,name
                                                users
                                              }
                                              company {
                                                users {
                                                  userId,name,email
                                                }
                                              }
                                            }`,
                                           {});
      if (!results.error) {
        this.roles = results.data.roles;
        results.data.company.users.forEach(user => user.selected = false);
        this.users = results.data.company.users;
        if (this.roles.length)
          this.selectUsersInRole(this.roles[0]);
      }
      this.loading = false;
  },
  methods: {
    setRole(role, created) {
      if (created) {
        this.roles.push(role);
        this.selectUsersInRole(role);
      }
      else
        this.roles.find(r => r.id === role.id).name = role.name;
    },
    deleteRole(role) {
      this.deleteRoleObject = role;
      this.showDelete = true;
    },
    async performDeleteRole() {
      this.loading = true;
      const results = await this.$apiCall(`mutation PlanningSchedulingRoles($id: ID!) {
                                             objectDelete(id:$id)
                                           }`,
                                          {id:this.deleteRoleObject.id});
      this.loading = false;
      if (!results.error) {
        const index = this.roles.findIndex(r => r.id === this.deleteRoleObject.id);
        this.roles.splice(index, 1);
        this.selectedRole = '';
        this.users.forEach(user => user.selected = false);
        this.showDelete = false;
      }
    },
    selectUsersInRole(role) {
      this.selectedRole = role.id;
      for (const user of this.users)
        user.selected = role.users.some(u => u === user.userId);
    },
    async setUsers() {
      const results = await this.$apiCall(`mutation PlanningSchedulingRoles($id:ID!, $users:[String]!) {
                                            roleSetUsers(id:$id, users:$users) {
                                              users
                                            }
                                          }`,
                                          {id:this.selectedRole, users:this.users.filter(user => user.selected).map(user => user.userId)});
      if (!results.error)
        this.roles.find(role => role.id === this.selectedRole).users = results.data.roleSetUsers.users;
    }
  }
}
</script>